import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";


const PostcodeFilter = ({ setFilter, value, setValue }) => {
  const [textBox, setTextBox] = useState("");
  const [open, setOpen] = React.useState(false);

  const [list, setList] = useState([]);
  const [filteredList, setFilteredList] = useState([...list]);
  const filterRef = React.useRef();

  const handleChange = (event) => {
    setTextBox(event.target.value);
    setValue((prev) => ({
      ...prev,
      postal_code: event.target.value,
    }));
    setFilter((prev) => ({
      ...prev,
      postal_code: event.target.value,
      page: 1,
    }));
  };

  const stopPropagation = (e) => {
    switch (e.key) {
      case "ArrowDown":
      case "ArrowUp":
      case "Home":
      case "End":
        break;
      default:
        e.stopPropagation();
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  return (
    <FormControl>
      <Select
        autoWidth
        displayEmpty
        size="small"
        value={value?.donation_name}
        open={open}
        onClose={handleClose}
        onOpen={handleOpen}
        renderValue={(selected) => {
          if (!selected) {
            return <Typography variant="big">Postcode</Typography>;
          }

          return selected;
        }}
        sx={{
          borderRadius: "16px",
          "&.Mui-focused": {
            "& .MuiOutlinedInput-notchedOutline": {
              boxShadow: "none",
              border: "1px solid",
              borderColor: "grey.main",
            },
          },
        }}
        onChange={(event) => handleChange(event)}
        id="demo-simple-select"
      >
        <MenuItem disabled>Postcode</MenuItem>
        <TextField
          placeholder="Filter"
          inputRef={filterRef}
          sx={{
            border: "none",
            borderColor: "",
            fontSize: "14px",
            marginBottom: "0.5em",
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "grey.border40",
              },
              "&.Mui-focused fieldset": {
                borderColor: "primary.main",
              },
            },
          }}
          value={textBox}
          size="small"
          onKeyDown={stopPropagation}
          onChange={handleChange}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <i class="las la-search la-lg"></i>
              </InputAdornment>
            ),
          }}
        />
        <Box p={2}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleClose}
          >
            Close
          </Button>
        </Box>
      </Select>
    </FormControl>
  );
};

export default PostcodeFilter;
